<svg
  width="14"
  height="14"
  class="loader"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10.5879 10.3787C12.3975 8.43305 12.3655 5.38345 10.4855 3.48985C9.74873 2.74449 8.79068 2.25733 7.75433 2.10105L7.80953 0.439453C9.2644 0.615116 10.617 1.27801 11.6471 2.32025C14.1663 4.85625 14.1967 8.95145 11.7455 11.5451L13.1383 12.9467L8.73033 13.1875L8.74233 8.52025L10.5879 10.3787ZM5.27033 0.811453L5.25833 5.47865L3.41273 3.62105C1.60313 5.56825 1.63513 8.61785 3.51513 10.5099C4.2518 11.2554 5.20991 11.7426 6.24633 11.8987L6.19113 13.5595C4.73627 13.3836 3.38358 12.721 2.35273 11.6795C-0.165667 9.14185 -0.196066 5.04665 2.25513 2.45465L0.862333 1.05145L5.27033 0.811453Z"
    fill="#A8ADB4" />
</svg>
